<template>
<div class="chapter">
<div class="inner_page">
<p class="ct" id="d6e983">
<b>The EVERYTHING<sub>®</sub> Series </b>
</p>
<p class="tx" id="d6e1073">
<b>Editorial </b>
</p>
<table border="1" cellpadding="1" cellspacing="1" frame="box" rules="all" summary="" width="100%">
<colgroup>
<col/>
<col/>
</colgroup>
<tbody>
<tr>
<td align="left" valign="top">Publishing Director 
</td>
<td align="left" valign="top">Gary M. Krebs
</td>
</tr>
<tr>
<td align="left" valign="top">Managing Editor 
</td>
<td align="left" valign="top">Kate McBride
</td>
</tr>
<tr>
<td align="left" valign="top">Copy Chief 
</td>
<td align="left" valign="top">Laura MacLaughlin
</td>
</tr>
<tr>
<td align="left" valign="top">Acquisitions Editor 
</td>
<td align="left" valign="top">Bethany Brown
</td>
</tr>
<tr>
<td align="left" valign="top">Development Editor 
</td>
<td align="left" valign="top">Karen Johnson Jacot
</td>
</tr>
<tr>
<td align="left" valign="top">Production Editor 
</td>
<td align="left" valign="top">Khrysti Nazzaro<br/>Jamie Wielgus</td>
</tr>
</tbody>
</table>
<p class="tx" id="d6e1143">
<b>Production </b>
</p>
<table border="1" cellpadding="1" cellspacing="1" frame="box" rules="all" summary="" width="100%">
<colgroup>
<col/>
<col/>
</colgroup>
<tbody>
<tr>
<td align="left" valign="top">Production Director 
</td>
<td align="left" valign="top">Susan Beale
</td>
</tr>
<tr>
<td align="left" valign="top">Production Manager 
</td>
<td align="left" valign="top">Michelle Roy Kelly
</td>
</tr>
<tr>
<td align="left" valign="top">Series Designers 
</td>
<td align="left" valign="top">Daria Perreault<br/>Colleen Cunningham
</td>
</tr>
<tr>
<td align="left" valign="top">Cover Design 
</td>
<td align="left" valign="top">Paul Beatrice<br/>Frank Rivera
</td>
</tr>
<tr>
<td align="left" valign="top">Layout and Graphics 
</td>
<td align="left" valign="top">Colleen Cunningham<br/>Rachael Eiben<br/>Michelle Roy Kelly<br/>Daria Perreault<br/>Erin Ring
</td>
</tr>
<tr>
<td align="left" valign="top">Series Cover Artist 
</td>
<td align="left" valign="top">Barry Littmann
</td>
</tr>
</tbody>
</table>
<p class="tx" id="d6e1223">
<b>Visit the entire Everything <sup>®</sup> Series at <a href="http://everything.com" id="d14e168" target="_blank">everything.com</a>
</b>
</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Sher_9781440522697_epub_c4_r1.vue?17b3ca60